import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumberRange]',
})
export class NumberRangeDirective {
  private regex: RegExp = new RegExp(/^\d{0,9}$/); // Modified to allow any number of digits up to 9
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    console.log('directive');

    if (!next.match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    let inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;
    if (!value.match(/^\d{0,9}$/)) {
      inputElement.value = value.slice(0, value.length - 1); // Remove last character
    }

    if (value.length < 6 || value.length > 9) {
      // Optionally, show an error message or styling here
    }
  }
}
